export default __webpack_public_path__ + "static/media/07.04d2196c.jpg";